var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container", attrs: { id: "goods-edit" } }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "" } },
          [
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div1" }, [_vm._v("矩阵管理")]),
            ]),
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div2" }, [_vm._v("客服管理")]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "content" },
      [
        _c("h2", [_vm._v("客服管理")]),
        _c(
          "el-form",
          { staticClass: "info-form", attrs: { "label-width": "120px" } },
          [
            _c(
              "el-form-item",
              { attrs: { label: "客服名称" } },
              [
                _c("el-input", {
                  staticStyle: { width: "30%" },
                  attrs: {
                    placeholder: "请输入客服名称",
                    maxlength: "10",
                    "show-word-limit": "",
                  },
                  model: {
                    value: _vm.name,
                    callback: function ($$v) {
                      _vm.name = $$v
                    },
                    expression: "name",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "联系电话" } },
              [
                _c("el-input", {
                  staticStyle: { width: "30%" },
                  attrs: { placeholder: "请输入联系电话" },
                  model: {
                    value: _vm.contact,
                    callback: function ($$v) {
                      _vm.contact = $$v
                    },
                    expression: "contact",
                  },
                }),
              ],
              1
            ),
            _c("el-form-item"),
            _c("el-form-item", { attrs: { label: "二维码" } }, [
              _c(
                "div",
                [
                  _c("headerPicture", {
                    attrs: { qrCodeUrl: _vm.qrCodeUrl },
                    on: {
                      getUrl: function ($event) {
                        return _vm.getImage($event)
                      },
                    },
                  }),
                ],
                1
              ),
              _c("span", [_vm._v("请上传二维码")]),
            ]),
          ],
          1
        ),
        _c(
          "div",
          {
            staticStyle: {
              width: "30%",
              "text-align": "center",
              "padding-bottom": "20px",
            },
          },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.submit()
                  },
                },
              },
              [_vm._v("确认")]
            ),
            _c("el-button", { on: { click: _vm.back } }, [_vm._v("返回")]),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }